module.exports = __webpack_public_path__ + "img/dice_w.27c6ea06.svg";